import { render, staticRenderFns } from "./TableType6.vue?vue&type=template&id=0c5d5406&"
import script from "./TableType6.vue?vue&type=script&lang=js&"
export * from "./TableType6.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports